var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showLandscapeNotif)?_c('div',{attrs:{"id":"landscape-notif"}},[_c('div'),_c('div',[_vm._m(0),_c('div',{staticClass:"title0"},[_vm._v(_vm._s(_vm.$t("Landscape.title")))])]),_c('div')]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{attrs:{"src":require("@/assets/images/landscape-img.svg"),"height":"80","width":"253","alt":""}})])
}]

export { render, staticRenderFns }